// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
//
// // Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
//
// // Components
import MainNav from './main-nav';
//
// // Contexts
import {RouteContext} from '../../../contexts/route-context';
import ScrollToTopButton from './scroll-to-top-button';

const Main = ({children}) => (
  <>
    <main className="main">
      <RouteContext.Provider value={useRouter()}>
        <MainNav>
          <div className="main--content">{children}</div>
        </MainNav>
      </RouteContext.Provider>
    </main>
    <ScrollToTopButton />
  </>
);

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
